const REPORT = {
  ROLEITEM: {
    STRONGLY_DISAGREE: 0,
    DISAGREE: 1,
    USUALLY: 2,
    AGREE: 3,
    STRONGLY_AGREE: 4,
  },
};

export default REPORT;



// WEBPACK FOOTER //
// ./src/constants/report.js